const canvas = document.getElementById('oilCanvas');
const ctx = canvas.getContext('2d');
const video = document.getElementById('oilVideo');

let w, h;
let isDrawing = false;
let lastX = 0;
let lastY = 0;
let checkingCleared = false;
let videoFrozen = false; // we'll freeze the video when user starts erasing

function resize() {
  w = canvas.width = window.innerWidth;
  h = canvas.height = window.innerHeight;
}
window.addEventListener('resize', resize);

// Draw video frame as the oil layer
function drawFrame() {
  if (!document.body.contains(canvas)) return; // stop if canvas removed

  // As long as the video isn't frozen, keep updating the frame
  if (!videoFrozen && !video.paused && !video.ended) {
    ctx.globalCompositeOperation = 'source-over';
    ctx.drawImage(video, 0, 0, w, h);
  }

  requestAnimationFrame(drawFrame);
}

// Get mouse/touch position
function getPos(e) {
  if (e.touches && e.touches[0]) {
    return { x: e.touches[0].clientX, y: e.touches[0].clientY };
  }
  return { x: e.clientX, y: e.clientY };
}

function handlePointerDown(e) {
  isDrawing = true;
  const pos = getPos(e);
  lastX = pos.x;
  lastY = pos.y;

  // On first touch/click, freeze the video on the current frame
  if (!videoFrozen) {
    videoFrozen = true;
    video.pause();
  }
}

function handlePointerUp() {
  isDrawing = false;
}

function handlePointerMove(e) {
  if (!isDrawing) return;
  e.preventDefault();

  const pos = getPos(e);

  // Erase oil where the mouse/finger moves
  ctx.save();
  ctx.globalCompositeOperation = 'destination-out';
  ctx.lineWidth = 90;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  ctx.beginPath();
  ctx.moveTo(lastX, lastY);
  ctx.lineTo(pos.x, pos.y);
  ctx.stroke();
  ctx.restore();

  lastX = pos.x;
  lastY = pos.y;

  if (!checkingCleared) {
    checkingCleared = true;
    requestAnimationFrame(checkClearedPercentage);
  }
}

// Check if enough oil is gone
function checkClearedPercentage() {
  const sampleW = Math.max(80, Math.floor(w * 0.25));
  const sampleH = Math.max(80, Math.floor(h * 0.25));

  const startX = (w - sampleW) / 2;
  const startY = (h - sampleH) / 2;
  const data = ctx.getImageData(startX, startY, sampleW, sampleH).data;

  let alphaSum = 0;
  for (let i = 3; i < data.length; i += 4) {
    alphaSum += data[i];
  }

  const maxAlphaSum = 255 * (data.length / 4);
  const remainingRatio = alphaSum / maxAlphaSum;

  if (remainingRatio < 0.2) {
    finishSplash();
  }

  checkingCleared = false;
}

// Fade out the canvas and hint
function finishSplash() {
  const hint = document.getElementById('continueHint');
  hint.style.transition = 'opacity 0.5s';
  hint.style.opacity = 0;

  canvas.style.transition = 'opacity 0.8s';
  canvas.style.opacity = 0;
  canvas.style.pointerEvents = 'none';

  setTimeout(() => {
    canvas.remove();
    hint.remove();
  }, 900);
}

// Mouse events
canvas.addEventListener('mousedown', handlePointerDown);
canvas.addEventListener('mousemove', handlePointerMove);
window.addEventListener('mouseup', handlePointerUp);

// Touch events
canvas.addEventListener('touchstart', handlePointerDown, { passive: false });
canvas.addEventListener('touchmove', handlePointerMove, { passive: false });
window.addEventListener('touchend', handlePointerUp);

// Start
resize();

// When the video can play, start drawing frames
video.addEventListener('canplay', () => {
  video.play();
  requestAnimationFrame(drawFrame);
});

// In case it's already ready
if (video.readyState >= 2) {
  video.play();
  requestAnimationFrame(drawFrame);
}
